import { useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { API, authHeaders } from "../lib/supabase";
import { useOnline } from "../lib/net";

export const openJobPdf = async (dispatchId, { download = false } = {}) => {
  const win = download ? null : window.open("", "_blank");
  try {
    const r = await fetch(`${API}/jobs/${dispatchId}/report.pdf${download ? "?download=1" : ""}`, { headers: await authHeaders() });
    if (!r.ok) throw new Error(r.status === 404 ? "Job not found" : "Could not build the PDF");
    const url = URL.createObjectURL(await r.blob());
    if (win) win.location = url;
    else { const a = document.createElement("a"); a.href = url; a.download = `dropit-job-${dispatchId.slice(0, 8)}.pdf`; a.click(); }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) { win?.close(); throw e; }
};

export const PdfButton = ({ dispatch, compact = false }) => {
  const online = useOnline();
  const [busy, setBusy] = useState(false);
  const done = dispatch.status === "completed";
  const local = dispatch.queued || String(dispatch.id).startsWith("local:");
  const disabled = !online || busy || local;
  const hint = !online ? "PDF needs internet" : local ? "Available once the job has synced" : undefined;
  const go = async (e) => {
    e?.preventDefault(); e?.stopPropagation();
    if (disabled) { if (hint) toast.message(hint); return; }
    setBusy(true);
    try { await openJobPdf(dispatch.id); } catch (err) { toast.error(err.message); }
    setBusy(false);
  };
  if (compact) {
    return <button type="button" className="icon-btn text-primary" onClick={go} aria-disabled={disabled ? "true" : undefined} title={hint || "View PDF"} aria-label="View job PDF" data-testid={`pdf-job-${dispatch.id}`} data-offline={!online ? "true" : undefined}><FileText size={16} /></button>;
  }
  return (
    <div>
      <button type="button" className={`${done ? "btn-primary" : "btn-secondary"} flex items-center justify-center gap-2 w-full`} onClick={go} aria-disabled={disabled ? "true" : undefined} data-testid="detail-pdf-button" data-offline={!online ? "true" : undefined}>
        <FileText size={16} /> {busy ? "Building PDF…" : done ? "Job report · View PDF" : "View PDF"}
      </button>
      {hint && <p className="text-xs text-muted mt-1 text-center" data-testid="detail-pdf-hint">{hint}</p>}
    </div>
  );
};
